import { EdContextMenuModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';

/**
 * This function is used to show a custom tooltip when hovering over a data table slot.
 * @param component the component instance that contains the data-table
 * @param text function that generates the tooltip text based on params
 * @returns void
 */
export function showCustomTooltip(component: any, text: (params: any) => string): Function {
    return (event: MouseEvent, params: any, hover: boolean): void => {
        if (hover) {
            component?.$EdContextMenu?.show(new EdContextMenuModel({
                className: 'wc-data-table-custom-tooltip',
                position: { x: event?.x, y: event?.y },
                options: [{ text: text(params) }],
            }));
        } else {
            component?.$EdContextMenu?.close();
        }
    };
}
